import { Moon, Sun } from "lucide-react";
import { useColorMode } from "@/context/ColorModeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { mode, toggle } = useColorMode();
  const dark = mode === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? "Passer en mode clair" : "Passer en mode sombre"}
      title={dark ? "Mode clair" : "Mode sombre"}
      className={`relative h-9 w-9 grid place-items-center rounded-full border border-border bg-card/60 backdrop-blur text-muted-foreground hover:text-foreground hover:border-genis/50 transition-colors ${className}`}
      data-testid="theme-toggle-btn"
    >
      <Sun className={`h-4 w-4 absolute transition-[opacity,transform] duration-300 ${dark ? "opacity-0 rotate-90 scale-50" : "opacity-100"}`} />
      <Moon className={`h-4 w-4 absolute transition-[opacity,transform] duration-300 ${dark ? "opacity-100" : "opacity-0 -rotate-90 scale-50"}`} />
    </button>
  );
};
